import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {SessionModel, UserSession} from '@/sdk';
import {CoreService} from '@/services/core.service';
import {Component} from 'vue-property-decorator';
@Component({
    components: {},
})
export default class PaymentAppBarComponent extends VueWrapper {
    public $refs!: {};

    public CoreSrv = new CoreService();
    public User = {};
    // public UserSrv = new UsersService();
    public userSession = new UserSession();

    public UserMenu = false;
    public UserMenuMobile = false;
    public myload = true;
    public whyMhParks = false;
    public featureMenus = false;

    public langMenu = false;

    public height = 70;

    public Session = new SessionModel();

    public mounted() {
        this.AddSubscription$ = this.userSession._session.subscribe(session => {
            this.Session = session ?? new SessionModel();

            if (this.Session.token && !this.Session.loginId) {
                this.UserLogout();
            }
        });

        window.addEventListener(
            'resize',
            () => {
                // console.log('aaaaaaaaaaa', this.$vuetify.breakpoint.name);
                const breakPoint = this.$vuetify.breakpoint.name;
                if (breakPoint === 'md') {
                    this.height = 90;
                } else {
                    this.height = 70;
                }
            },
            {passive: true}
        );
    }

    public get getLocale() {
        return this.$i18n.locale.toUpperCase();
    }

    public langClick(lang: string) {
        this.$i18n.locale = lang;
        this.langMenu = false;
        localStorage.setItem('locale', lang);
    }

    public get isSiteSelected() {
        return this.$route.params['siteId'] !== undefined;
    }
    public get isSiteSetupRoute() {
        return this.$route.name === 'site-setup';
    }

    public get navHeight() {
        const breakPoint = this.$vuetify.breakpoint.name;
        if (breakPoint === 'md') {
            this.height = 90;
        } else {
            this.height = 76;
        }
        return this.height;
    }

    public get title() {
        if (this.$route.name === 'Main') {
            return 'Site Setup';
        } else if (this.$route.name === 'sites-list') {
            return 'Sites List';
        } else if (this.$route.name === 'Job Main') {
            return 'Job Setup';
        } else if (this.$route.name === 'Team Main') {
            return 'Team Setup';
        } else if (this.$route.name === 'UserSetupMain') {
            return 'User Setup';
        } else if (this.$route.name === 'diagram-view') {
            return 'Diagram View';
        }
        return '';
    }

    get num() {
        return this.$vuetify.breakpoint.width <= 1169;
    }

    public UserLogout() {
        this.UserMenu = false;
        this.userSession.clear();
        this.$router.push({name: 'signin'});
    }
}
